<template>
  <div class="modalStyle">
    <a-row type="flex" justify="space-between" class="formula">
      <h3 class="title">{{formula.formulaName}}</h3>
      <a-button @click="setState({formula:{}})" type="link" class="close-button" icon="close" />
    </a-row>
    <a-tabs :tabBarGutter="0" size="small" @change="tabsChange" :activeKey="tabSelect" :animated="false">
        <a-tab-pane key="1" tab="配方原料" style="padding:10px">
          <formula-mix-raw ref="raw" :showDiffOnly="showDiffOnly" @diff-only-change="onDiffOnlyChange" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="营养需要量" style="padding:10px">
          <formula-mix-nutrition ref="nutrition" />
        </a-tab-pane>
        <a-select slot="tabBarExtraContent" v-if="tabSelect == 1" placeholder="所有原料" style="width:150px" v-model="rawCurrentType">
          <a-select-option :key="index" :value="index" v-for="(item,index) in rawTypes">{{item}}</a-select-option>
        </a-select>
        <a-space slot="tabBarExtraContent" v-if="tabSelect == 2">
          <a-checkbox v-model="showNutDiffOnly" @change="onNutDiffOnlyChange">产品对比差异项</a-checkbox>
          <a-select placeholder="所有原料" style="width:150px" v-model="nutritionCurrentType">
            <a-select-option :key="index" :value="index" v-for="(item,index) in ['显示所有指标','仅展示有值的指标','仅展示有约束的指标']">{{item}}</a-select-option>
          </a-select>
        </a-space>
      </a-tabs>
  </div>
</template>

<script>
import { formulaMixins } from '../unitls'
import FormulaMixNutrition from './FormulaMixNutrition.vue'
import FormulaMixRaw from './FormulaMixRaw.vue'

export default {
  mixins:[formulaMixins],
  components:{FormulaMixNutrition, FormulaMixRaw},
  watch:{
    nutritionCurrentType(val){
      window.localStorage.setItem('nutritionCurrentType',val)
      // 切换指标分类时，取消产品对比差异项
      this.showNutDiffOnly = false
      if(this.$refs['nutrition']) this.$refs['nutrition'].filterNutritionData(val, false)
    },
    rawCurrentType(val){
      window.localStorage.setItem('rawCurrentType',val)
      // 切换原料分类时，取消产品对比差异项
      this.showDiffOnly = false
      this.$nextTick(() => {
        if(this.$refs['raw']) this.$refs['raw'].filterData(val, false)
      })
    },
    formula(item){
      if(item.id){
        this.tabSelect = '1'
        this.rawCurrentType = 0
        this.nutritionCurrentType = 0
        this.showDiffOnly = false
        this.showNutDiffOnly = false
      }
    },
    resRaw(val){
      if(val) {
        this.rawCurrentType = 0
        this.nutritionCurrentType = 0
        this.showDiffOnly = false
        this.showNutDiffOnly = false
      }
    },
    resNut(val){
      if(val) {
        this.rawCurrentType = 0
        this.nutritionCurrentType = 0
        this.showDiffOnly = false
        this.showNutDiffOnly = false
      }
    },
 
  },
  mounted(){
    let rawCurrentType = window.localStorage.getItem('rawCurrentType')
    let nutritionCurrentType = window.localStorage.getItem('nutritionCurrentType')
    if(!rawCurrentType){
      rawCurrentType = 0
    }
    this.rawCurrentType = Number(rawCurrentType)
    if(!nutritionCurrentType){
      nutritionCurrentType = 0
    }
    this.nutritionCurrentType = Number(nutritionCurrentType)
  },
  data(){
    return{
      nutritionCurrentType: 0,
      rawCurrentType: null,
      tabSelect:'1',
      showDiffOnly: false,
      showNutDiffOnly: false
    }
  },
  methods:{
    tabsChange(val){
      this.tabSelect = val
    },
    // 产品对比差异项（补充料原料）：子组件勾选/取消时同步状态，与原料分类互斥
    onDiffOnlyChange(val) {
      if (val) {
        // 选中差异项时，重置原料分类为"所有原料"
        this.rawCurrentType = 0
      }
      this.showDiffOnly = val
    },
    // 产品对比差异项（营养需要量）：勾选/取消勾选，与指标分类互斥
    onNutDiffOnlyChange() {
      if (this.showNutDiffOnly) {
        // 选中差异项时，重置指标分类为"显示所有指标"
        this.nutritionCurrentType = 0
      }
      const showDiff = this.showNutDiffOnly
      this.$nextTick(() => {
        if (this.$refs['nutrition']) {
          this.showNutDiffOnly = showDiff
          this.$refs['nutrition'].filterNutritionData(this.nutritionCurrentType, showDiff)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .formula{
    padding:15px 10px 12px;
  }
  .title{
    margin:0;
    padding:0;
  }
  .modalStyle{
    // padding:10px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #fff;
    z-index: 2;
  }
</style>
